import React, { useState, useEffect } from 'react'
import { Autocomplete, IconButton, Button, Card, Paper, Typography } from "@mui/material";
import { Stack } from "@mui/system";
import { useStyles } from '../../theme/theme';
import { TextField } from '@material-ui/core';
import DriveFolderUploadIcon from '@mui/icons-material/DriveFolderUpload';
import { Box } from "@mui/system";
import "../../css/index.css"
import axios from "../../config/authaxios";
import DeleteIcon from '@mui/icons-material/Delete';
import EditIcon from '@mui/icons-material/Edit';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import Dropdown from "../../css/dropdown.module.scss";







const Linkskupage = () => {


    const [couponList, setCouponList] = useState([])
    const [isProcess, setIsProcess] = useState(false)
    const classes = useStyles();
    const [pageSize, setPageSize] = useState(25);
    const [platform, setPlatform] = useState();
    const [imageUpload, setImageUploaded] = useState('')
    const [smallImageUpload, setSmallImageUpload] = useState('')
    const [skuData, setSkuData] = useState([])
    const [propsData, setPropsData] = useState({});
    const [editPropsData, setEditPropsData] = useState({})
    const [open, setOpen] = useState(false)
    const [openEdit, setOpenEdit] = useState(false)
    const [page, setPage] = useState(0)
    const [limit, setLimit] = useState(10)
    const [isMore, setIsMore] = useState(false);



    const handleClose = () => {
        setOpen(false);
    };

    const handleClose2 = () => {
        setOpenEdit(false);
    };




    useEffect(() => {
        fetchSku()
        fetchVouchersImage()
    }, [limit])

    const fetchSku = async () => {

        const data = await axios.get('admin/qs/voucher-skus')
        console.log("data-->", data.data.response)
        setSkuData([...data?.data?.response])


    }


    const handleEdit = async () => {

        const data = await axios.put('admin/qs/edit-voucher-image', editPropsData)


        setOpenEdit(false);
        setEditPropsData({})
        alert(data.data.message)
        fetchVouchersImage()



    }







    const handleSubmit = async () => {
        const obj = {}
        obj.sku = platform
        obj.image =imageUpload
        obj.small=smallImageUpload
        const data = await axios.post('admin/qs/add-voucher-image', obj)



        console.log(data.data, "data")

        alert(data.data.message)


        if (data.data.status) {
            setPlatform('')
            setImageUploaded('')
            setSmallImageUpload('')
            setPage(0)
            fetchVouchersImage()


        }



    }

    const fetchVouchersImage = async () => {
        setPage(0)
        const data = await axios.get(`admin/qs/vouchers-image/0/${limit}`)
        console.log("dfetchVouchersImageata-->", data.data.response)
        if (data.data.response.length < limit) {
            setIsMore(true)
        }
        // setSkuData([...data?.data?.response])
        setCouponList([...data.data.response])
        setPage(1)


    }

    const handleDelete = async () => {
        console.log("propsData-->", propsData);
        const data = await axios.delete('admin/qs/remove-voucher-image', {
            data: propsData
        })

        alert(data.data.message)
        fetchVouchersImage()
        setOpen(false)
    }

    // const platformValue = [{
    //     name: "Gamerpe",
    //     value: 1
    // },
    // {
    //     name: "TopUp-X",
    //     value: 2
    // }]



    const handlefileInput = (e) => {
        const Dataform = new FormData();
        Dataform.append("file", e.target.files[0]);
        let FileSize = Number(e.target.files[0].size / 1000);
        var file = e.target.files[0];
        var _URL = window.URL || window.webkitURL;
        let img = new Image();
        var width, height;
        img.onload = function () {
            // //console.log(img, file);
            width = this.width;
            height = this.height;

            axios.post(`/admin/upload-image`, Dataform).then((res) => {
                //console.log(">>Image_url>>", res.data.Image.url);
                console.log(e.target.id,"id")
                // setCoupons({ ...coupons, image: res.data.Image.url });
                if(e.target.id=='image'){
                    setImageUploaded(res.data.Image.url)
                //  setEditPropsData({ ...editPropsData, 'image': res.data.Image.url })
                }else if(e.target.id=='small'){
                    setSmallImageUpload(res.data.Image.url)
                    // setEditPropsData({ ...editPropsData, 'small': res.data.Image.url })
                } else if(e.target.id=='edit_image'){
                    // setSmallImageUpload(res.data.Image.url)
                    setEditPropsData({ ...editPropsData, 'image': res.data.Image.url })
                }else{
                    // setSmallImageUpload(res.data.Image.url)
                    setEditPropsData({ ...editPropsData, 'small': res.data.Image.url })
                }
                
                // setImage(res.data.Image.url);
                //console.log("coupons-->",coupons)
            });
            alert(`Image is Successfully Uploaded, Your file size is ${FileSize}`);

        };
        img.onerror = function () {
            alert("not a valid file: " + file.type);
        };
        img.src = _URL.createObjectURL(file);
    };


    const Showmore = async () => {

        const data = await axios.get(`admin/qs/vouchers-image/${page}/${limit}`)
        console.log("dfetchVouchersImageata-->", data.data.response)
        // setSkuData([...data?.data?.response])

        setCouponList([...couponList, ...data.data.response])
        if (data.data.response.length < limit) {
            setIsMore(true)
        }
        setPage(prev => prev + 1)

    }
    return (
        <>
            <Card sx={{ p: 4 }}>
                <Stack spacing={2} direction='row'>
                    <div className='platFormBox' style={{ display: 'flex', width: "50%" }}>
                        <h2>sku</h2>
                        <Autocomplete
                            disablePortal
                            className='platformAutoComplete'
                            options={
                                skuData
                            }
                            onChange={(event, newValue) => {
                                setPlatform(newValue?.sku);
                            }}
                            getOptionLabel={option => option?.sku}
                            renderInput={(params) => (
                                <TextField
                                    {...params}
                                    label="sku"
                                />
                            )}
                        />
                    </div>
                    <div>
                        <Box sx={{ my: 2 }}>
                            <label htmlFor="image">
                                <input
                                    accept="image/*"
                                    id="image"
                                    type="file"
                                    onChange={handlefileInput}
                                    style={{ display: 'none' }}
                                />
                                <Button
                                    variant="contained"
                                    component="span"
                                    endIcon={<DriveFolderUploadIcon />}
                                    color="info"
                                >
                                    Upload Image
                                </Button>
                            </label>


                        </Box>
                        {imageUpload && <img src={imageUpload} width='100' alt='image_uploaded' />}
                    </div>
                    <div>
                        <Box sx={{ my: 2 }}>
                            <label htmlFor="small">
                                <input
                                    accept="image/*"
                                    id="small"
                                    type="file"
                                    onChange={handlefileInput}
                                    style={{ display: 'none' }}
                                />
                                <Button
                                    variant="contained"
                                    component="span"
                                    endIcon={<DriveFolderUploadIcon />}
                                    color="info"
                                >
                                    Upload mini Image
                                </Button>
                            </label>


                        </Box>
                        {smallImageUpload && <img src={smallImageUpload} width='100' alt='image_uploaded' />}
                    </div>
                </Stack>
                <Stack spacing={2} direction='row'>

                    <Button variant='contained' onClick={handleSubmit}>Submit</Button>
                </Stack>
            </Card>

            <Typography style={{ color: "#646777", fontSize: "1.7rem", width: "50%", marginTop: "10px" }}>Coupon List</Typography>


            <Card style={{ margin: '10px auto', display: 'flex', flexDirection: 'column', alignItems: 'center', padding: '10px' }}>

                <div style={{ height: "auto", overflow: "auto" }}>
                    <Stack spacing={2} direction='row' style={{ display: "flex", justifyContent: 'flex-end', }}>
                        <div className={Dropdown.dropdown}>

                            <Button variant="contained" disabled={!isMore ? false : true} color='info' sx={{ my: 2 }} className={Dropdown.dropbtn} onClick={Showmore}>More</Button>
                        </div>


                        <div className={Dropdown.dropdown} style={{ cursor: "pointer", height: "100%" }}>
                            <Button variant="contained" color='info' sx={{ my: 2 }}>limit:{limit}</Button>
                            <div className={Dropdown.dropdown_content}>
                                <a className={limit === 10 ? "disabled" : "notDisabled"} onClick={() => { setLimit(10); setPage(0) }}>10</a>
                                <a disabled={limit === 50 ? true : false} onClick={() => { setLimit(50); setPage(0) }}>50</a>
                                <a disabled={limit === 100 ? true : false} onClick={() => { setLimit(100); setPage(0) }}>100</a>
                                <a disabled={limit === 500 ? true : false} onClick={() => { setLimit(500); setPage(0) }}>500</a>
                                <a disabled={limit === 1000 ? true : false} onClick={() => { setLimit(1000); setPage(0) }}>1000</a>
                            </div>
                        </div>






                    </Stack>
                    <table style={{ borderCollapse: "collapse" }}>
                        <thead style={{ background: "#DC8449", color: "#fff", position: "sticky", top: "0px" }}>
                            <tr>
                                <th>S. No.</th>
                                <th>Id</th>
                                <th>SKU</th>
                                <th>Image</th>
                                <th>small image</th>
                                <th>Created At</th>
                                <th>Edit</th>
                                <th>Delete</th>




                            </tr>
                        </thead>
                        <tbody style={{ overflowX: "auto" }}>
                            {couponList.length > 0 ? couponList.map((item, index) => {
                                return (

                                    <tr key={index}>
                                        <td>{index + 1}</td>
                                        <td>{item?._id}</td>
                                        <td>{item?.sku}</td>
                                        <td><img src={item?.image} alt='img' width='50px' height='50px' /></td>
                                        <td>{item?.small ? <img src={item?.small} alt='img' width='50px' height='50px' />:"---"}</td>
                                        <td>{item?.created_at}</td>
                                        <td><IconButton
                                            onClick={() => {
                                                setOpenEdit(true);
                                                setEditPropsData({
                                                    sku: item?.sku,
                                                    image: item?.image
                                                })
                                            }}><EditIcon color='success' />
                                        </IconButton ></td>

                                        <td><IconButton
                                            onClick={() => {
                                                setPropsData({
                                                    sku: item?.sku,

                                                });
                                                setOpen(true);

                                            }}><DeleteIcon color='error' />
                                        </IconButton ></td>


                                    </tr>
                                );
                            }) : <div style={{ display: "flex", alignItems: "center", justifyContent: "center" }}>No Data Available</div>}
                        </tbody>


                    </table>


                    <Stack spacing={2} direction='row' style={{ display: "flex", justifyContent: 'flex-end', }}>
                        <div className={Dropdown.dropdown}>

                            <Button variant="contained" disabled={couponList.length > 0 && !isMore ? false : true} color='info' sx={{ my: 2 }} className={Dropdown.dropbtn} onClick={Showmore}>More</Button>
                        </div>

                        {/* 
                        <div className={Dropdown.dropdown} style={{ cursor: "pointer",height:"100%" }}>
                            <Button variant="contained" color='info' sx={{ my: 2 }}>limit:{limit}</Button>
                            <div className={Dropdown.dropdown_content}>
                                <a className={limit === 25 ? "disabled" : "notDisabled"} onClick={() => { setLimit(25); setPage(0) }}>25</a>
                                <a disabled={limit === 50 ? true : false} onClick={() => { setLimit(50); setPage(0) }}>50</a>
                                <a disabled={limit === 100 ? true : false} onClick={() => { setLimit(100); setPage(0) }}>100</a>
                                <a disabled={limit === 500 ? true : false} onClick={() => { setLimit(500); setPage(0) }}>500</a>
                                <a disabled={limit === 1000 ? true : false} onClick={() => { setLimit(1000); setPage(0) }}>1000</a>
                            </div>
                        </div> */}






                    </Stack>

                </div>



            </Card>


            <Dialog
                open={open}
                onClose={handleClose}
                aria-labelledby="alert-dialog-title"
                aria-describedby="alert-dialog-description"
            >
                <DialogTitle id="alert-dialog-title">
                    {"Do you want to delete?"}
                    {/* {JSON.stringify(propsData)} */}
                </DialogTitle>
                {/* <DialogContent>
                    <DialogContentText id="alert-dialog-description">
                        Let Google help apps determine location. This means sending anonymous
                        location data to Google, even when no apps are running.
                    </DialogContentText>
                </DialogContent> */}
                <DialogActions>
                    <Button onClick={handleClose}>Disagree</Button>
                    <Button onClick={handleDelete} autoFocus>
                        Agree
                    </Button>
                </DialogActions>
            </Dialog>


            {/* edit dialog */}

            <Dialog
                open={openEdit}
                onClose={handleClose2}
                aria-labelledby="alert-dialog-title"
                aria-describedby="alert-dialog-description"


            >
                {/* {JSON.stringify(editPropsData)} */}
                <DialogTitle id="alert-dialog-title">
                    {"Edit"}
                </DialogTitle>
                <DialogContent style={{ display: 'flex', flexDirection: 'column', width: '1200px' }}>
                    <DialogContentText id="alert-dialog-description">
                        <Stack spacing={2}>
                            <div className='platFormBox' style={{ display: 'flex', width: "50%" }}>
                                <h2>sku</h2>
                                <Autocomplete
                                    // disablePortal
                                   
                                    className='platformAutoComplete'
                                    
                                    
                                    // value={editPropsData?.sku}
                                    inputValue={editPropsData?.sku}
                                    
                                    renderInput={(params) => (
                                        <TextField
                                            {...params}
                                            label="sku"
                                        />
                                    )}
                                    disabled
                                />

                                {/* <Autocomplete
                                    {...defaultProps}
                                    id="disabled"
                                    disabled
                                    renderInput={(params) => (
                                        <TextField {...params} label="disabled" variant="standard" />
                                    )}
                                /> */}
                            </div>
                            <div>
                                <Box sx={{ my: 2 }}>
                                    <label htmlFor="edit_image">
                                        <input
                                            accept="image/*"
                                            id="edit_image"
                                            type="file"
                                            onChange={handlefileInput}
                                            style={{ display: 'none' }}
                                        />
                                        <Button
                                            variant="contained"
                                            component="span"
                                            endIcon={<DriveFolderUploadIcon />}
                                            color="info"
                                        >
                                            Upload Image
                                        </Button>
                                    </label>
                                    
                                    {editPropsData.image && <img src={editPropsData.image} width='100' alt='image_uploaded' />}

                                </Box>

                                <Box sx={{ my: 2 }}>
                                    <label htmlFor="edit_small">
                                        <input
                                            accept="image/*"
                                            id="edit_small"
                                            type="file"
                                            onChange={handlefileInput}
                                            style={{ display: 'none' }}
                                        />
                                        <Button
                                            variant="contained"
                                            component="span"
                                            endIcon={<DriveFolderUploadIcon />}
                                            color="info"
                                        >
                                            Upload small Image
                                        </Button>
                                    </label>
                                    
                                    {editPropsData.small && <img src={editPropsData.small} width='100' alt='image_uploaded' />}

                                </Box>
                            </div>
                        </Stack>
                        <Stack spacing={5} style={{ width: "15%" }}>

                            <Button variant='contained' onClick={handleEdit}>Update</Button>
                        </Stack>
                    </DialogContentText>
                </DialogContent>
                <DialogActions>
                    <Button onClick={handleClose2}>Close</Button>
                    {/* <Button onClick={handleEdit} autoFocus>
                        Agree
                    </Button> */}
                </DialogActions>
            </Dialog>
        </>
    )
}

export default Linkskupage